import React, { Fragment } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

class SimpleModal extends React.Component {
  render() {
    const {
      toggleModal,
      modalStatus,
      buttonName,
      renderButton,
      children,
      fullscreen,
      minWidth,
      onRequestClose,
      customStyles,
      marginRight,
    } = this.props;

    const modalStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: marginRight ?? "-50%",
        transform: "translate(-50%, -50%)",
        maxHeight: "90%",
        borderRadius: "0",
        border: "2px solid white",
        minWidth,
        maxWidth: minWidth,
        ...customStyles,
      },
    };
    const closeButton = {
      position: "fixed",
      right: "15px",
      top: "20px",
      border: "none",
      background: "none",
      padding: 0,
    };

    const closeButtonIcon = {
      height: "40px",
      width: "40px",
      cursor: "pointer",
    };

    const closeButtonText = {
      position: "fixed",
      right: "19px",
      top: "45px",
      fontSize: "12px",
      cursor: "pointer",
    };

    const fullScreenModalStyles = {
      position: "relative",
      content: {
        width: "100%",
        height: "100%",
        margin: "0",
        padding: "0",
        position: "absolute",
        borderRadius: "0",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
      },
    };

    return (
      <Fragment>
        {renderButton ? (
          renderButton()
        ) : (
          <button className="usa-button" onClick={toggleModal}>
            {buttonName || "Add Data"}
          </button>
        )}
        <Modal
          id="simple-modal"
          style={fullscreen ? fullScreenModalStyles : modalStyles}
          isOpen={modalStatus}
          onRequestClose={onRequestClose || toggleModal}
          overlayClassName="Overlay"
        >
          <div
            style={closeButton}
            onClick={onRequestClose || toggleModal}
            onKeyUp={(e) => {
              if (e.key === "Escape") onRequestClose() || toggleModal();
            }}
          >
            <MdClose style={closeButtonIcon} />
            <p style={closeButtonText}>CLOSE</p>
          </div>
          {children}
        </Modal>
      </Fragment>
    );
  }
}

export default SimpleModal;
